import React, { useContext } from 'react';
import { ThemeContext } from '../../hooks/ThemeContext';
import { Search } from 'lucide-react';

const SearchBar = ({ value, onChange, placeholder = "Rechercher..." }) => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === 'dark';

  return (
    <div className="relative">
      <Search className={`absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 ${isDark ? 'text-gray-400' : 'text-gray-500'}`} />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`w-full pl-10 pr-4 py-2 rounded-lg border text-sm transition-colors ${
          isDark 
            ? 'bg-[#0b0b0c] border-white/10 text-white placeholder-gray-400 focus:border-rose-500' 
            : 'bg-white border-gray-200 text-gray-800 placeholder-gray-500 focus:border-rose-500'
        } focus:outline-none focus:ring-2 focus:ring-rose-500/20`}
      />
    </div>
  );
};

export default SearchBar;
